// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3Bs_U","title":"Header_title__ucSej","left":"Header_left__2-89Z","clinicName":"Header_clinicName__262XI"};